import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportPokerPloResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportPokerPloInner() {
    return <PlayerLevelReportBase tab="pokerPlo" columnsSettingsViewType="PlayerLevelReportPokerPlo" />;
}

const PlayerLevelReportPokerPloWithAccess = withAccessCheck(PlayerLevelReportPokerPloInner, playerLevelReportPokerPloResource);

export const PlayerLevelReportPokerPlo = withTraceErrorBoundary(PlayerLevelReportPokerPloWithAccess, ErrorModal);
